var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerUserTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3352_2532",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3352_2532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 29.3337C14.1569 29.3337 12.4235 28.9837 10.8013 28.2837C9.17908 27.5837 7.76797 26.6337 6.56797 25.4337C5.36797 24.2337 4.41797 22.8226 3.71797 21.2003C3.01797 19.5781 2.66797 17.8448 2.66797 16.0003C2.66797 14.1559 3.01797 12.4225 3.71797 10.8003C4.41797 9.1781 5.36797 7.76699 6.56797 6.56699C7.76797 5.36699 9.17908 4.41699 10.8013 3.71699C12.4235 3.01699 14.1569 2.66699 16.0013 2.66699C17.8457 2.66699 19.5791 3.01699 21.2013 3.71699C22.8235 4.41699 24.2346 5.36699 25.4346 6.56699C26.6346 7.76699 27.5846 9.1781 28.2846 10.8003C28.9846 12.4225 29.3346 14.1559 29.3346 16.0003C29.3346 17.8448 28.9846 19.5781 28.2846 21.2003C27.5846 22.8226 26.6346 24.2337 25.4346 25.4337C24.2346 26.6337 22.8235 27.5837 21.2013 28.2837C19.5791 28.9837 17.8457 29.3337 16.0013 29.3337Z",
    fill: "#58A55D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9504 17.2617L19.1504 12.0617C19.3949 11.8173 19.706 11.6951 20.0838 11.6951C20.4615 11.6951 20.7726 11.8173 21.0171 12.0617C21.2615 12.3062 21.3838 12.6173 21.3838 12.9951C21.3838 13.3728 21.2615 13.684 21.0171 13.9284L14.8838 20.0617C14.6171 20.3284 14.306 20.4617 13.9504 20.4617C13.5949 20.4617 13.2838 20.3284 13.0171 20.0617L10.8838 17.9284C10.6393 17.684 10.5171 17.3728 10.5171 16.9951C10.5171 16.6173 10.6393 16.3062 10.8838 16.0617C11.1282 15.8173 11.4393 15.6951 11.8171 15.6951C12.1949 15.6951 12.506 15.8173 12.7504 16.0617L13.9504 17.2617Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerUserTick);
export default __webpack_public_path__ + "static/media/powerUserTick.288bfc9f416d42064e5076c915156c91.svg";
export { ForwardRef as ReactComponent };